<div class="container admin">
  <div class="row admin">
    <p class="admin-warning"><b>{{ 'admin.warning' | translate }}</b></p>
  </div>
  <app-admin-settings-new (reloadEntries)="settings.reload()"></app-admin-settings-new>
  <div class="row admin">
    <div class="col-md-2 pl-0 mb-0"><p class="admin"><b>{{ 'admin.settings.column.key' | translate }}</b></p></div>
    <div class="col-md-3 pl-0 mb-0"><p class="admin"><b>{{ 'admin.settings.column.value' | translate }}</b></p></div>
    <div class="col-md-3 pl-0 mb-0"><p class="admin"><b>{{ 'admin.settings.column.description' | translate }}</b></p></div>
    <div class="col-md-2 pl-0 mb-0"><p class="admin"><b>{{ 'admin.settings.column.date' | translate }}</b></p></div>
    <div class="col-md-2 pl-0 mb-0"></div>
  </div>
  @for (setting of settings.value(); track setting.id) {
    <div class="row admin"
         app-admin-settings-entry
         [set]="setting"
         (reloadEntries)="settings.reload()"
         (deleted)="onSettingDeleted(setting.id)">
    </div>
  }
</div>
